import axios from '@/axios/axios'

export default {
  namespaced: true,
  actions: {
    requestDeleteByFileGroupId(context, fileGroupId) {
      return axios
        .post('/api/file/deleteByFileGroupId', null, {
          params: {
            fileGroupId: fileGroupId,
          },
        })
        .then((response) => {
          return Promise.resolve(response)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    uploadAvatar(_, file) {
      if (!file) return

      const form = new FormData()

      form.append('avatar', file)

      return axios({
        url: '/api/account/upload-avatar',
        method: 'POST',
        data: form,
      })
        .then((payload) => {
          console.log(payload.data.filePath)
          return Promise.resolve(payload.data.filePath)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
  },
}
